import type { FrontendOnlyPieces } from '../../hooks/useSettings/WebsiteSettings';
import { VAGO_BUSINESS_INTERNAL_NAME } from './constants';

// VaGo Assure — frontend-only pieces; all data fields live on the backend
export const frontendPieces: FrontendOnlyPieces = {
  slug: 'vago',
  businessFilter: (business) =>
    business.internalName === VAGO_BUSINESS_INTERNAL_NAME,
};

// Always returns false in production because the reference equality check in
// generateUseUseSettings never matches a freshly-built WebsiteSettings.
// Kept for backward compatibility with components that import this hook.
export const useUsingVagoSettings = () => false;
